import almatvIptv from "@/assets/clients/almatv-iptv.jpg";
import megogoMedia from "@/assets/clients/megogo-media.jpg";
import kyivstar from "@/assets/clients/kyivstar.jpg";
import sarkor from "@/assets/clients/sarkor.jpg";
import sweettv from "@/assets/clients/sweettv.jpg";
import metrotv from "@/assets/clients/metrotv.jpg";
import beelineTv from "@/assets/clients/beeline-tv.jpg";
import okTv from "@/assets/clients/oktv.jpg";
import { useSite } from "@/hooks/use-site";

const cases = [
  {
    img: beelineTv,
    client: "Beeline Kazakhstan",
    tagKey: "clientTagFullPackage",
    noteKey: "clientNoteBeeline",
  },
  {
    img: okTv,
    client: "OK.TV",
    tagKey: "clientTagCoBranding",
    noteKey: "clientNoteOkTv",
  },
  {
    img: kyivstar,
    client: "Kyivstar TB",
    tagKey: "clientTagFullPackage",
    noteKey: "clientNoteKyivstar",
  },
  {
    img: almatvIptv,
    client: "Alma TV",
    tagKey: "clientTagRetailKit",
    noteKey: "clientNoteAlmaTv",
  },
  {
    img: sarkor,
    client: "Sarkor Telecom",
    tagKey: "clientTagCustomApp",
    noteKey: "clientNoteSarkor",
  },
  {
    img: sweettv,
    client: "SWEET.TV",
    tagKey: "clientTagCoBranding",
    noteKey: "clientNoteSweetTv",
  },
  {
    img: megogoMedia,
    client: "MEGOGO",
    tagKey: "clientTagWhiteLabel",
    noteKey: "clientNoteMegogo",
  },
  {
    img: metrotv,
    client: "Metro TV",
    tagKey: "clientTagFullPackage",
    noteKey: "clientNoteMetroTv",
  },
] as const;

export function ClientShowcase() {
  const { messages } = useSite();

  return (
    <section
      id="clients"
      className="relative border-t border-border/60 bg-gradient-to-b from-background to-muted/20 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-border/60 bg-card px-3 py-1 text-xs text-muted-foreground">
            <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
            {messages.clientsEyebrow}
          </div>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">
            {messages.clientsTitle}{" "}
            <span className="text-gradient">{messages.clientsTitleAccent}</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{messages.clientsDescription}</p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {cases.map((c, i) => (
            <figure
              key={c.client + i}
              className="group relative overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-glow hover:border-primary/30"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-muted/40 to-muted/10">
                <img
                  src={c.img}
                  alt={`${c.client} — ${messages[c.tagKey]} ${messages.clientImageAltSuffix}`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <span className="absolute left-3 top-3 rounded-full border border-border/60 bg-background/80 px-2.5 py-1 text-[11px] font-medium text-foreground backdrop-blur">
                  {messages[c.tagKey]}
                </span>
              </div>
              <figcaption className="p-4">
                <div className="text-sm font-semibold tracking-tight">{c.client}</div>
                <div className="mt-1 text-xs text-muted-foreground">{messages[c.noteKey]}</div>
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-muted-foreground">{messages.clientsOutro}</p>
      </div>
    </section>
  );
}
